import React from 'react';
import NavigationCard, { BaseImage } from '../../../navigation/NavigationCard';
import { InternalNavigation } from '../../../navigation/helper';
import {
  CustomListsNavigationCard,
  QueryTemplatesNavigationCard,
  SegmentsNavigationCard,
} from './CommonNavigationCards';
import {
  CAN_READ_CUSTOM_LIST,
  CAN_READ_ENTITY_GROUP,
  CAN_READ_QUERY_TEMPLATE,
  CAN_READ_SCENARIO,
} from '../../../auth/permissions';
import Has from '../../../auth/Has';
import { faArrowsTurnToDots } from '@fortawesome/pro-duotone-svg-icons';

const Monitoring = () => {
  return (
    <>
      <Has anyPermissions={[CAN_READ_SCENARIO]}>
        <h1 className={'m-b-8'}>Scenario Configuration</h1>
        <div style={{ display: 'flex', gap: '32px' }}>
          <Has allPermissions={CAN_READ_SCENARIO}>
            <NavigationCard
              title={'Scenarios'}
              description={
                'Select Scenarios from the Library or write your own, and manage them by editing, testing, activating, and archiving.'
              }
              to={InternalNavigation.scenarios}
              image={{
                base: BaseImage.base6,
                icon: faArrowsTurnToDots,
              }}
            />
          </Has>
        </div>
      </Has>
      <Has anyPermissions={[CAN_READ_ENTITY_GROUP, CAN_READ_CUSTOM_LIST, CAN_READ_QUERY_TEMPLATE]}>
        <h1 className={'m-b-8 m-t-32'}>Scenario Inputs</h1>
        <div style={{ display: 'flex', gap: '32px' }}>
          <SegmentsNavigationCard />
          <CustomListsNavigationCard />
          <QueryTemplatesNavigationCard base={BaseImage.base2} />
        </div>
      </Has>
    </>
  );
};

export default Monitoring;
